// @flow

import React, { Component } from 'react';
import moment               from 'moment';
import { getTranslate }     from 'react-localize-redux';
import { connect }          from 'react-redux';
import './footer.css';

class Footer extends Component {

  render() {
    const { translate } = this.props;
    const termsAndConditions = process.env.REACT_APP_TERMS_AND_CONDITIONS ? process.env.REACT_APP_TERMS_AND_CONDITIONS : '';

    return (
      <div className='footer'>
        <footer className='container-fluid'>
          { translate('common.footer_main_text') }
          <br />
          { translate('common.footer_secondary_text') }
          <a href={termsAndConditions}>
            { translate('common.footer_secondary_link') }
          </a>
          <br /><br />
          { translate('common.footer_notice', { year: moment().year() }) }
        </footer>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  translate: getTranslate(state.locale)
});
export default connect(mapStateToProps)(Footer);



// WEBPACK FOOTER //
// ./src/components/session/footer/footer.js